import { Close } from '@mui/icons-material';
import { DialogTitle, Grid, IconButton, Typography } from '@mui/material';

export type CustomDialogTitleProps = {
    onClose: () => void;
    title?: string;
};

export const CustomDialogTitle = ({ onClose, title }: CustomDialogTitleProps) => (
    <DialogTitle sx={({ palette }) => ({ height: '64px', bgcolor: palette.primary[300] })}>
        <Grid container justifyContent="space-between">
            <Grid item xs>
                {title && (
                    <Typography fontSize="20px" fontWeight={700} color="secondary">
                        {title}
                    </Typography>
                )}
            </Grid>
            <Grid item xs="auto">
                <IconButton onClick={onClose} disableRipple sx={{ width: '40px', height: '32px', borderRadius: '100px', bgcolor: 'white' }}>
                    <Close htmlColor="#858585" />
                </IconButton>
            </Grid>
        </Grid>
    </DialogTitle>
);
